export function update(session, payload) {
  return {type: `${payload.__typename}/update`, session, payload: Object.assign({}, payload, {session})};
}
